import { useState, useRef } from "react";

import styles from "./OtpInput.module.scss";

function OTPInput({ length = 6, onChange, error, type = "number" }) {
	const [otp, setOtp] = useState(Array(length).fill(""));
	const inputsRef = useRef([]);

	const handleChange = (value, index) => {
		if (!/^[a-zA-Z0-9]$/.test(value) && value !== "") return;

		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);
		onChange(newOtp.join(""));

		if (value && index < length - 1) {
			inputsRef.current[index + 1]?.focus();
		}
	};

	const handleKeyDown = (e, index) => {
		if (e.key === "Backspace" && otp[index] === "") {
			if (index > 0) {
				inputsRef.current[index - 1]?.focus();
			}
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const pasteData = e.clipboardData.getData("text").slice(0, length);
		if (!/^[a-zA-Z0-9]+$/.test(pasteData)) return;

		const newOtp = pasteData
			.split("")
			.concat(Array(length).fill(""))
			.slice(0, length);

		setOtp(newOtp);
		onChange(newOtp.join(""));
		inputsRef.current[Math.min(pasteData.length - 1, length - 1)]?.focus();
	};

	return (
		<div className={styles.otpContainer}>
			{otp.map((value, index) => (
				<input
					key={index}
					ref={(el) => (inputsRef.current[index] = el)}
					type={type}
					value={value}
					onChange={(e) => handleChange(e.target.value, index)}
					onKeyDown={(e) => handleKeyDown(e, index)}
					onPaste={handlePaste}
					maxLength={1}
					className={`${styles.otpInput} ${
						error ? styles.error : styles.normal
					}`}
				/>
			))}
		</div>
	);
}

export default OTPInput;
